export default
{
  UintOwnerTypes: [],
  UintOwnerType: {},
}
